import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import "../styles/update/hero.css";
import "../../styles/update/hero.css";

const texts = [
  { label: "Full-Stack Developer", icon: "💻" },
  { label: "AI Automation Engineer", icon: "🤖" },
  { label: "IoT & Embedded Systems Creator", icon: "🌐" },
  { label: "Mobile App Developer", icon: "📱" },
];

// SVG Illustrations for each service
const ServiceIllustrations = {
  // Full-Stack Developer
  0: (
    <svg viewBox="0 0 400 400" className="hero-image-svg">
      <defs>
        <filter id="glow-fullstack">
          <feGaussianBlur stdDeviation="8" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-fullstack" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#3b82f6", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#8b5cf6", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>

      {/* Glowing background circle */}
      <circle
        cx="200"
        cy="200"
        r="150"
        fill="url(#grad-fullstack)"
        opacity="0.1"
        filter="url(#glow-fullstack)"
      />

      {/* Code editor window */}
      <rect
        x="80"
        y="100"
        width="240"
        height="200"
        rx="12"
        fill="url(#grad-fullstack)"
        opacity="0.9"
        filter="url(#glow-fullstack)"
      />
      <rect x="80" y="100" width="240" height="30" rx="12" fill="#1e293b" />

      {/* Window dots */}
      <circle cx="100" cy="115" r="5" fill="#ef4444" />
      <circle cx="120" cy="115" r="5" fill="#fbbf24" />
      <circle cx="140" cy="115" r="5" fill="#10b981" />

      {/* Code lines */}
      <line
        x1="100"
        y1="160"
        x2="280"
        y2="160"
        stroke="#e0e7ff"
        strokeWidth="4"
        opacity="0.8"
      />
      <line
        x1="120"
        y1="180"
        x2="260"
        y2="180"
        stroke="#c7d2fe"
        strokeWidth="4"
        opacity="0.7"
      />
      <line
        x1="120"
        y1="200"
        x2="240"
        y2="200"
        stroke="#a5b4fc"
        strokeWidth="4"
        opacity="0.7"
      />
      <line
        x1="100"
        y1="220"
        x2="270"
        y2="220"
        stroke="#e0e7ff"
        strokeWidth="4"
        opacity="0.8"
      />
      <line
        x1="120"
        y1="240"
        x2="250"
        y2="240"
        stroke="#c7d2fe"
        strokeWidth="4"
        opacity="0.7"
      />
      <line
        x1="120"
        y1="260"
        x2="280"
        y2="260"
        stroke="#a5b4fc"
        strokeWidth="4"
        opacity="0.7"
      />

      {/* Decorative brackets */}
      <text
        x="100"
        y="180"
        fill="#60a5fa"
        fontSize="24"
        style={{ fontWeight: "bold" }}
      >
        {"{"}
      </text>
      <text
        x="270"
        y="250"
        fill="#60a5fa"
        fontSize="24"
        style={{ fontWeight: "bold" }}
      >
        {"}"}
      </text>
    </svg>
  ),
  // AI Automation Engineer
  1: (
    <svg viewBox="0 0 400 400" className="hero-image-svg">
      <defs>
        <filter id="glow-ai">
          <feGaussianBlur stdDeviation="10" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-ai" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#ec4899", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#8b5cf6", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>

      {/* Glowing background */}
      <circle
        cx="200"
        cy="200"
        r="160"
        fill="url(#grad-ai)"
        opacity="0.15"
        filter="url(#glow-ai)"
      />

      {/* Robot head */}
      <rect
        x="130"
        y="120"
        width="140"
        height="140"
        rx="20"
        fill="url(#grad-ai)"
        opacity="0.9"
        filter="url(#glow-ai)"
      />

      {/* Antenna */}
      <line
        x1="200"
        y1="90"
        x2="200"
        y2="120"
        stroke="url(#grad-ai)"
        strokeWidth="6"
        filter="url(#glow-ai)"
      />
      <circle cx="200" cy="80" r="10" fill="#ec4899" filter="url(#glow-ai)" />

      {/* Eyes */}
      <circle cx="165" cy="170" r="20" fill="#fbbf24" filter="url(#glow-ai)" />
      <circle cx="235" cy="170" r="20" fill="#fbbf24" filter="url(#glow-ai)" />
      <circle cx="165" cy="170" r="10" fill="#1e293b" />
      <circle cx="235" cy="170" r="10" fill="#1e293b" />

      {/* Mouth - digital smile */}
      <rect x="160" y="215" width="15" height="8" fill="#60a5fa" />
      <rect x="180" y="215" width="15" height="8" fill="#60a5fa" />
      <rect x="200" y="215" width="15" height="8" fill="#60a5fa" />
      <rect x="220" y="215" width="15" height="8" fill="#60a5fa" />

      {/* Circuit lines */}
      <path
        d="M 130 180 L 110 180 L 110 200"
        stroke="#22d3ee"
        strokeWidth="3"
        fill="none"
        opacity="0.7"
      />
      <path
        d="M 270 180 L 290 180 L 290 200"
        stroke="#22d3ee"
        strokeWidth="3"
        fill="none"
        opacity="0.7"
      />
      <circle cx="110" cy="200" r="5" fill="#22d3ee" />
      <circle cx="290" cy="200" r="5" fill="#22d3ee" />
    </svg>
  ),
  // IoT & Embedded Systems
  2: (
    <svg viewBox="0 0 400 400" className="hero-image-svg">
      <defs>
        <filter id="glow-iot">
          <feGaussianBlur stdDeviation="8" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-iot" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#10b981", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#06b6d4", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>

      {/* Glowing background */}
      <circle
        cx="200"
        cy="200"
        r="150"
        fill="url(#grad-iot)"
        opacity="0.12"
        filter="url(#glow-iot)"
      />

      {/* Central hub */}
      <circle
        cx="200"
        cy="200"
        r="40"
        fill="url(#grad-iot)"
        filter="url(#glow-iot)"
      />
      <circle cx="200" cy="200" r="30" fill="#1e293b" />
      <circle cx="200" cy="200" r="15" fill="#10b981" filter="url(#glow-iot)" />

      {/* Connected nodes */}
      <circle
        cx="120"
        cy="120"
        r="25"
        fill="url(#grad-iot)"
        opacity="0.8"
        filter="url(#glow-iot)"
      />
      <circle
        cx="280"
        cy="120"
        r="25"
        fill="url(#grad-iot)"
        opacity="0.8"
        filter="url(#glow-iot)"
      />
      <circle
        cx="120"
        cy="280"
        r="25"
        fill="url(#grad-iot)"
        opacity="0.8"
        filter="url(#glow-iot)"
      />
      <circle
        cx="280"
        cy="280"
        r="25"
        fill="url(#grad-iot)"
        opacity="0.8"
        filter="url(#glow-iot)"
      />

      {/* Connection lines */}
      <line
        x1="200"
        y1="200"
        x2="120"
        y2="120"
        stroke="#22d3ee"
        strokeWidth="3"
        opacity="0.6"
        strokeDasharray="5,5"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="10"
          dur="1s"
          repeatCount="indefinite"
        />
      </line>
      <line
        x1="200"
        y1="200"
        x2="280"
        y2="120"
        stroke="#22d3ee"
        strokeWidth="3"
        opacity="0.6"
        strokeDasharray="5,5"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="10"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </line>
      <line
        x1="200"
        y1="200"
        x2="120"
        y2="280"
        stroke="#22d3ee"
        strokeWidth="3"
        opacity="0.6"
        strokeDasharray="5,5"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="10"
          dur="1.4s"
          repeatCount="indefinite"
        />
      </line>
      <line
        x1="200"
        y1="200"
        x2="280"
        y2="280"
        stroke="#22d3ee"
        strokeWidth="3"
        opacity="0.6"
        strokeDasharray="5,5"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="10"
          dur="1.6s"
          repeatCount="indefinite"
        />
      </line>

      {/* Node icons (simplified microchips) */}
      <rect x="110" y="110" width="20" height="20" fill="#1e293b" />
      <rect x="270" y="110" width="20" height="20" fill="#1e293b" />
      <rect x="110" y="270" width="20" height="20" fill="#1e293b" />
      <rect x="270" y="270" width="20" height="20" fill="#1e293b" />
    </svg>
  ),
  // Mobile App Developer
  3: (
    <svg viewBox="0 0 400 400" className="hero-image-svg">
      <defs>
        <filter id="glow-mobile">
          <feGaussianBlur stdDeviation="8" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-mobile" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#f59e0b", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#ef4444", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>

      {/* Glowing background */}
      <circle
        cx="200"
        cy="200"
        r="160"
        fill="url(#grad-mobile)"
        opacity="0.12"
        filter="url(#glow-mobile)"
      />

      {/* Phone frame */}
      <rect
        x="130"
        y="80"
        width="140"
        height="240"
        rx="20"
        fill="url(#grad-mobile)"
        opacity="0.9"
        filter="url(#glow-mobile)"
      />
      <rect x="140" y="95" width="120" height="210" rx="8" fill="#1e293b" />

      {/* Notch */}
      <rect x="170" y="95" width="60" height="12" rx="6" fill="#0f172a" />

      {/* App icons grid */}
      <circle cx="165" cy="140" r="12" fill="#3b82f6" opacity="0.9" />
      <circle cx="200" cy="140" r="12" fill="#10b981" opacity="0.9" />
      <circle cx="235" cy="140" r="12" fill="#8b5cf6" opacity="0.9" />

      <circle cx="165" cy="175" r="12" fill="#ec4899" opacity="0.9" />
      <circle cx="200" cy="175" r="12" fill="#f59e0b" opacity="0.9" />
      <circle cx="235" cy="175" r="12" fill="#06b6d4" opacity="0.9" />

      <circle cx="165" cy="210" r="12" fill="#6366f1" opacity="0.9" />
      <circle cx="200" cy="210" r="12" fill="#14b8a6" opacity="0.9" />
      <circle cx="235" cy="210" r="12" fill="#f43f5e" opacity="0.9" />

      {/* Bottom dock */}
      <rect
        x="150"
        y="260"
        width="100"
        height="30"
        rx="15"
        fill="#334155"
        opacity="0.6"
      />
      <circle cx="170" cy="275" r="8" fill="#60a5fa" opacity="0.9" />
      <circle cx="200" cy="275" r="8" fill="#34d399" opacity="0.9" />
      <circle cx="230" cy="275" r="8" fill="#a78bfa" opacity="0.9" />

      {/* Notification dot */}
      <circle cx="245" cy="130" r="6" fill="#ef4444" filter="url(#glow-mobile)">
        <animate
          attributeName="opacity"
          values="1;0.5;1"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
};

export default function Hero({ portfolioRef }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = () => {
    if (portfolioRef?.current) {
      window.scrollTo({
        top: portfolioRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="hero-container">
      <div className="hero-left">
        <p className="hero-intro">I'm a</p>

        <div className="hero-animated-text">
          <AnimatePresence mode="wait">
            <motion.div
              key={texts[index].label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="hero-role">
                {texts[index].icon} {texts[index].label}
              </h1>
            </motion.div>
          </AnimatePresence>
        </div>

        <p className="hero-subtext">
          Building innovative, scalable, and intelligent digital solutions —
          from mobile apps to AI-powered automation and IoT integrations.
        </p>

        <button className="projects-btn mt-5" onClick={scrollToSection}>
          View My Projects
        </button>
      </div>

      <div className="hero-right">
        <AnimatePresence mode="wait">
          <motion.div
            key={texts[index].label}
            initial={{ opacity: 0, scale: 0.8, rotate: -10 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            exit={{ opacity: 0, scale: 0.8, rotate: 10 }}
            transition={{ duration: 0.7, type: "spring", stiffness: 100 }}
            className="hero-image-wrapper"
          >
            {ServiceIllustrations[index]}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
